import { render } from "./ProfileCompanyComponent.vue?vue&type=template&id=342adafa"
import script from "./ProfileCompanyComponent.vue?vue&type=script&lang=js"
export * from "./ProfileCompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__